"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APSegmentedButton = _interopRequireDefault(require("../../common/APSegmentedButton"));
var _APInlineButton = _interopRequireDefault(require("../../common/APInlineButton"));
var _commonComponent = require("../../../propTypes/commonComponent");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./TransfersFiltersComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('transfers-filters');
var TransfersFiltersComponent = function TransfersFiltersComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('transfer'),
    t = _useTranslation.t;
  var resetActivePage = props.resetActivePage,
    getTransfers = props.getTransfers,
    OMSId = props.OMSId,
    AccountId = props.AccountId;
  var tabs = {
    sentTransfers: 'sentTransfers',
    receivedTransfers: 'receivedTransfers',
    sentRequests: 'sentRequests',
    receivedRequests: 'receivedRequests'
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('select-buttons')
  }, /*#__PURE__*/_react["default"].createElement(_APSegmentedButton["default"], {
    name: "transfersFilters",
    defaultValue: tabs.sentTransfers,
    items: [{
      value: tabs.sentTransfers,
      text: t('Sent Transfers')
    }, {
      value: tabs.receivedTransfers,
      text: t('Received Transfers')
    }, {
      value: tabs.sentRequests,
      text: t('Sent Requests')
    }, {
      value: tabs.receivedRequests,
      text: t('Received Requests')
    }],
    styleName: _commonComponent.styleNames.additive,
    customClass: baseClasses(),
    onClick: resetActivePage
  })), /*#__PURE__*/_react["default"].createElement(_APInlineButton["default"], {
    icon: "refresh",
    customClass: baseClasses('refresh-transfers'),
    text: t('Refresh Transfers'),
    onClick: function onClick() {
      getTransfers(OMSId, AccountId);
    }
  }));
};
var _default = exports["default"] = TransfersFiltersComponent;